import React from 'react';
import './index.css';
import ReactDOM from 'react-dom';
import {SamuraiTSApp} from './App';


ReactDOM.render(
    //<React.StrictMode>
<SamuraiTSApp/>,
    document.getElementById("root")
);



